module.exports = __webpack_public_path__ + "img/resolved-status.8ce10bc3.svg";